export const JSONAPI_CONFIGURE = 'JSONAPI_CONFIGURE';
export const JSONAPI_CONFIGURE_DOCS_SDK = 'JSONAPI_CONFIGURE_DOCS_SDK';
export const WORKFLOWS_API_CONFIGURE = 'WORKFLOWS_API_CONFIGURE';
export const OXYGEN_CONFIGURE_START = 'OXYGEN_CONFIGURE_START';
export const OXYGEN_CONFIGURE_ASYNC = 'OXYGEN_CONFIGURE_ASYNC';
export const OXYGEN_CONFIGURE_ASYNC_PENDING = 'OXYGEN_CONFIGURE_ASYNC_PENDING';
export const OXYGEN_CONFIGURE_ASYNC_FULFILLED = 'OXYGEN_CONFIGURE_ASYNC_FULFILLED';
export const OXYGEN_CONFIGURE_ASYNC_REJECTED = 'OXYGEN_CONFIGURE_ASYNC_REJECTED';
export const DOCUMENT_COLLECTION_CONFIGURE = 'DOCUMENT_COLLECTION_CONFIGURE';
export const DOCUMENTS_WITH_ISSUES_FETCH = 'DOCUMENTS_WITH_ISSUES_FETCH';
export const DOCUMENT_CONFIGURE = 'DOCUMENT_CONFIGURE';
export const DOCUMENT_CONFIGURE_PENDING = 'DOCUMENT_CONFIGURE_PENDING';
export const DOCUMENT_CONFIGURE_FULFILLED = 'DOCUMENT_CONFIGURE_FULFILLED';
export const DOCUMENT_CONFIGURE_REJECTED = 'DOCUMENT_CONFIGURE_REJECTED';
export const SET_SHEETS_CONFIGURATION = 'SET_SHEETS_CONFIGURATION';
export const ANALYTICS_CONFIGURE = 'ANALYTICS_CONFIGURE';

export const configureJsonApiAction = (apiConfig) => {
  return {
    type: JSONAPI_CONFIGURE,
    payload: apiConfig,
  };
};

export const configureJsonApiDocsSDKAction = docsSDK => ({
  type: JSONAPI_CONFIGURE_DOCS_SDK,
  payload: docsSDK,
});

export const configureAnalyticsAction = (analyticsConfig) => {
  return {
    type: ANALYTICS_CONFIGURE,
    payload: analyticsConfig,
  };
};

export const configureWorkflowsApiAction = (apiConfig) => {
  return {
    type: WORKFLOWS_API_CONFIGURE,
    payload: apiConfig,
  };
};

export const configureOxygenAction = (oxygenPromises) => {
  return {
    type: OXYGEN_CONFIGURE_START,
    payload: oxygenPromises,
  };
};

export const setOxygenEntitiesAction = payload => ({
  type: OXYGEN_CONFIGURE_ASYNC_FULFILLED,
  payload,
});

export const configureDocumentAction = (documentConfig) => {
  const { documentPromise } = documentConfig;
  return {
    type: DOCUMENT_CONFIGURE,
    payload: {
      promise: documentPromise,
    },
  };
};

export const setDocumentAction = document => ({
  type: DOCUMENT_CONFIGURE_FULFILLED,
  payload: document,
});

export const configureSheetsAction = ({ currentSheets = [], sheetList = []}) => {
  return {
    type: SET_SHEETS_CONFIGURATION,
    payload: { sheetList, currentSheets },
  };
};

export const fetchUrns = (urn) => {
  return {
    type: DOCUMENTS_WITH_ISSUES_FETCH,
    payload: Array.isArray(urn) ? urn : [urn],
  };
};
